import { render } from "./EvalModelsPage.vue?vue&type=template&id=514e9bb4&ts=true"
import script from "./EvalModelsPage.vue?vue&type=script&lang=ts"
export * from "./EvalModelsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__